export const leavingReasons = [
  'Antigüedad',
  'Apertura del propio negocio',
  'Despido justificado',
  'Cambio de ciudad',
  'Cierre de la empresa',
  'Condiciones inadecuadas de trabajo ',
  'Dedicación al negocio familiar',
  'Desentendimiento con colegas de trabajo',
  'Desentendimiento con mi jefe',
  'Disminución de personal',
  'Disminución por el COVID 19',
  'Inadaptación a la cultura de la empresa',
  'Inadaptación a la función',
  'Inadaptación al ambiente de trabajo',
  'Insatisfacción salarial',
  'Jubilación por antigüedad',
  'Mejor oportunidad laboral',
  'Negociación - mutuo acuerdo',
  'Problemas de salud',
  'Problemas con el horario',
  'Problemas familiares',
  'Problemas financieros',
  'Reestructuración de personal',
  'Renuncia',
  'Solicitud del superior inmediato',
  'Término del contrato predeterminado',
  'Término del Contrato por período de prueba',
  'Traspaso para otra empresa del grupo',
  'Viaje al exterior',
  'He sufrido acoso moral',
  'He sufrido acoso sexual',
]
